/**
 * User Integrations API Service
 * =============================
 * Per-user OAuth integrations (currently: Google Drive).
 * Used by the Profile page to connect/disconnect Drive and show status.
 */

import apiClient from './client';

/**
 * Get the current user's Google Drive connection status.
 */
export const getGoogleDriveStatus = async () => {
  const response = await apiClient.get('/api/v1/users/me/google-drive/status');
  return response.data.data;
};

/**
 * Request the Google OAuth consent URL to start the connect flow.
 * The caller should navigate/redirect the browser to `authorize_url`.
 */
export const initiateGoogleDriveConnect = async () => {
  const response = await apiClient.get('/api/v1/users/me/google-drive/connect');
  return response.data.data;
};

/**
 * Revoke the user's Google Drive tokens and delete the stored connection.
 */
export const disconnectGoogleDrive = async () => {
  const response = await apiClient.delete('/api/v1/users/me/google-drive');
  return response.data.data;
};
